import React, { useState, useEffect, useMemo } from "react";
import SharesDataService from "../services/SharesService";
import { useSelector } from 'react-redux';
import BeautifulTable from "../../components/BeautifulTable";
import { fNumber } from "../../utils/formatNumber";
 
const SharesUser = (props) => {
  const [shares, setShares] = useState([]);

  const { user: currentUser } = useSelector((state) => state.auth);
  const currentUserId = currentUser?.id;

  useEffect(() => {
    retrieveShares();
  }, []); // eslint-disable-line

  const retrieveShares = () => {
    SharesDataService.getAll(currentUserId)
      .then((response) => setShares(response.data ?? response))
      .catch((e) => console.log(e));
  };

  const columns = useMemo(
    () => [
      { Header: "Date", accessor: "date", Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : "") },
      { Header: "Amount", accessor: "amount", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Transaction type", accessor: "creditOrDebit" },
      { Header: "Description", accessor: "description" },
      { Header: "New Balance", accessor: "newBalance", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Posted Date", accessor: "createdAt", Cell: ({ value }) => (value ? new Date(value).toLocaleString() : "") }
    ],
    []
  );

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <BeautifulTable
          columns={columns}
          data={shares}
          pageSize={10}
          onRowClick={(row) => props.history?.push && props.history.push(`/dashboard/shares/${row.id || row._id}`)}
        />
      </div>
    </div>
  );
};

export default SharesUser;
